import axios from '@/libs/axios';
import { useQuery } from '@tanstack/react-query';
import { DetailQueryKey, Urls } from '../constant';
//
export const detail = data => {
  return axios.post(Urls.detailUrl, data);
};
export const useDetail = ({
  id,
  config
}) => {
  return useQuery({ ...config,
    queryKey: [DetailQueryKey, id],
    queryFn: () => detail({
      id
    })
  });
};